import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Application from '../Application';
import BracketAttachment from './BracketAttachment/BracketAttachment';
import GeneralCalc from './GeneralCalc/GeneralCalc';
import Rebar from './Rebar/Rebar';
import SafetyBarrier from './SafetyBarrier/SafetyBarrier';
import WoodConnection from './WoodConnection/WoodConnection';

class Dimension extends Component {

  static propTypes = {
    type: PropTypes.string
  };

  componentMap = {
    [Application.types.GENERAL_CALCULATION]: GeneralCalc,
    [Application.types.BRACKET_ATTACHMENT]: BracketAttachment,
    [Application.types.SAFETY_BARRIER]: SafetyBarrier,
    [Application.types.REBAR_REINFORCEMENT]: Rebar,
    [Application.types.WOOD_CONNECTION]: WoodConnection, 
  };

  render() {
    if (this.props.type) {
      const Component = this.componentMap[this.props.type];

      return (
        <Component type={this.props.type} appStatus={this.props.appStatus} designStandard={this.props.designStandard}/>
      );
    }

    return null;
  }

}

const mapState = state => ({
  type: state.main.appType,
  appStatus: state.main.status,
  designStandard: state.main.localization.designStandard
});

export default connect(mapState)(Dimension);



// WEBPACK FOOTER //
// ./src/views/Dimension/index.js